import { smartPushState, eventedPushState } from '../vendor/evented-history-state-functions';
import { getUrlArray } from '../vendor/url-helper-functions';
import { updateFewGridCardsClasses } from './few-grid-cards';

(function($) {

	var $filterSelectHistory = $("#filter-select-history");

	$filterSelectHistory.on("change", function(event) {

		var $window = $(window);
		var $this = $(this);
		var filter = $this.val();
		var filterby = $this.find("option:selected").attr("data-filterby");
		//Check Scroll Pos
		var windowsize = $window.width();
		var scrollPos = $('html, body').scrollTop();
		var $pageHeader = $('#page-header');
		var headerOffset = $pageHeader.length ? $pageHeader.offset() : null;
		var headerPos = headerOffset ? headerOffset.top : 0;
		var headerHeight = $pageHeader.length ? $pageHeader.height() : 0;
		//Checker
		var checker = headerPos + headerHeight;
		//Adjustment
		var adjustHeight = checker + 85;
		//If Desktop
		if (windowsize > 639) {
			adjustHeight = checker - 150;
		}
		if (filter && filter !== "all") {
			smartPushState(filterby, filter, null, true);
		} else {
			// Team hub "All" maps to /team-hub/ (not /team-hub/all/).
			var urlArray = getUrlArray();
			if (urlArray && urlArray.length >= 4) {
				eventedPushState(
					{ filterby: 'all', filter: 'all' },
					'',
					'/' + urlArray[3] + '/'
				);
			}
		}
		//Scroll Helper
		if(scrollPos >= checker){
			$('html, body').animate({scrollTop: adjustHeight}, 'fast');
		};
	});
})(jQuery);

export function filterItems(filterby, filter, slug) {

	//Add Checker to avoid a "null" caching error//
	if(!filter){
		filter = "all";
	}

	if(filter){

	//select option from select
	var $filterSelectHistory = jQuery("#filter-select-history");

	$filterSelectHistory.find("option").removeAttr("selected");
	$filterSelectHistory
		.find("option[value='" + filter + "']")
		.prop("selected", true);
	//filter items
	var $items = jQuery(".filter-item");
	$items.removeClass("is-hidden");
	//if not all
	if (filter !== "all") {
		$items.addClass("is-hidden");
		$items.each(function() {
			var terms = jQuery(this).data(filterby);
			//add space so that an array can always be made
			terms += " ";
			//split terms into array incase one term contains another e.g. south-west and south
			if (terms && terms.includes(" ")) {
				terms = terms.split(" ");
				if (terms.indexOf(filter) != -1) {
					jQuery(this).removeClass("is-hidden");
				}
			}
		});
	}
	}

	updateFewGridCardsClasses(jQuery("#team-grid"), ".team-member");
}
